import * as Factory from 'factory.ts'
import faker from 'faker'

import { type PaymentTermApiModel } from '../PaymentTermApiModel'

export const PaymentTermApiModelStub =
  Factory.Sync.makeFactory<PaymentTermApiModel>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.random.words()),
    active: true,
    description: Factory.each(() => faker.random.words()),
  })
